import { render, staticRenderFns } from "./ShipRecordDetail.vue?vue&type=template&id=d836b726&scoped=true"
import script from "./ShipRecordDetail.vue?vue&type=script&lang=js"
export * from "./ShipRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipRecordDetail.vue?vue&type=style&index=0&id=d836b726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d836b726",
  null
  
)

export default component.exports